import createQueryHook from '@segment/utils/createQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
import { fetchAbmIndustryPage } from '../../../staticSiteBackend/templates/abmIndustryPages';
export var createSingleAbmIndustryPageQuery = function createSingleAbmIndustryPageQuery(client, slug) {
  return [["templatePages/singleAbmIndustryPageQuery", slug], function () {
    return fetchAbmIndustryPage({
      client: client,
      slug: slug
    });
  }];
};
export var useSingleAbmIndustryPageQuery = createQueryHook(createSingleAbmIndustryPageQuery, useStaticSiteBackend, {
  staleTime: Infinity
});